import type { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";

import { PagesStyled } from "src/app/pages/pagesStyled";
import { routes } from "../../../core/router/config/routes";

export const ErrorPage = ({ error }: FallbackProps) => {
    const { t } = useTranslation();
    const { message } = error;

    // if (isDevelopment()) {
    //     throw new Error(message);
    // }

    return (
        <PagesStyled>
            <p className="aevi-card-title">{t("core.notifications.error.title")}</p>
            <p className="aevi-text">{t("common.error")}</p>
            <p className="aevi-card-title">{t("common.error.details")}</p>
            <div className="aevi-text">{t(message)}</div>
            <div>
                <a className="aevi-link" href={routes.landingPage.path}>
                    {t("common.goHome")}
                </a>
            </div>
        </PagesStyled>
    );
};
